import colors from 'styles/colors'

export const styles = {
  modal: {
    content: {
      paddingTop: 44,
      paddingBottom: 110,
      backgroundColor: colors.snowflake
    }
  },
  container: {
    width: '50%',
    margin: '0 auto'
  },
  logo: {
    logo: {
      width: 150,
      height: 50
    }
  },
  content: {
    marginTop: 35,
    padding: 37,
    borderRadius: 4,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,0.17)',
    backgroundColor: colors.white
  },
  title: {
    fontFamily: 'Barlow',
    fontWeight: 700,
    fontSize: 28,
    letterSpacing: 0.4,
    color: colors.primary
  },
  description: {
    marginTop: 20,
    fontFamily: 'Barlow',
    fontSize: 16,
    lineHeight: '21px',
    color: colors.lightGray
  },
  inputsContainer: {
    marginTop: 36
  },
  input: {
    containerWithLabel: {
      marginBottom: 21
    },
    textInputWithLabel: {
      paddingLeft: 0,
      border: 0,
      borderBottom: `1px solid ${colors.pannikin}`,
      letterSpacing: 0
    },
    labelContainer: {
      left: 0
    }
  },
  button: {
    button: {
      width: '70%',
      height: 45,
      marginTop: 20,
      borderRadius: 22.5
    }
  }
}
